import React from 'react'
import Icon from 'components/shared/Icon'
import TooltipWrapper from 'components/TooltipWrapper'

const ActionButton = ({ icon, onClick, label, show = true, tooltip = false, className }) => !show
  ? null
  : (
    <TooltipWrapper condition={!!tooltip} text={tooltip}>
      <button
        className={className}
        data-event-category='Account'
        data-event-action={label}
        onClick={onClick}
      >
        {icon && <Icon name={icon} className='valign-sub' />} {label}
      </button>
    </TooltipWrapper>
    )

export default ActionButton
